import styled from '@emotion/styled';

import { COLORS } from '@clutter/clean';

export const Superscript = styled.sup`
  color: ${COLORS.hippo};
  font-size: 8px;
`;
